import { useOutletContext, useParams } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"
import { useState } from 'react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import { createDeviceForm, fetchDeviceForms } from '../../../state/actions/deviceFormActions'
import { NotificationTypes, addNotification } from "../../../state/actions/notificationActions.js"

import { ComponentDeviceTypeFormsUnsupported } from "../../../utils/constants.js"
import { isset } from "../../../utils/utils.js"

function UploadFormModal({show, handleCancel, deviceTypes}) {

	const { beId } = useParams()
	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()

	//console.log("Device types:")
	//console.log(deviceTypes)

	// used to update UI state when selecting a device type
	const [rerenderWorkaroundState, workaround] = useState(false)
	const rerender = () => { workaround(!rerenderWorkaroundState) }

	const fileSignal = useSignal(null)
	const diskFileNameSignal = useSignal('')
	const selectedDeviceTypeSignal = useSignal('')
	const userEnteredFormNameSignal = useSignal('')
	const descriptionSignal = useSignal('')
	const mimeTypeSignal = useSignal('application/octet-stream')

	const enableUploadButtonComputed = useComputed(() => {
		return isset(selectedDeviceTypeSignal.value)
			//&& isset(userEnteredFormNameSignal.value)
			&& isset(diskFileNameSignal.value)
			&& isset(mimeTypeSignal.value)
			&& isset(fileSignal.value)
	})

	const handleDeviceTypeChange = function (event) {
		selectedDeviceTypeSignal.value = event.target.value
		rerender()
	}

	const handleUserEnteredFormNameChanged = function (event) {
		userEnteredFormNameSignal.value = event.target.value
	}

	const handleDescriptionChanged = function (event) {
		descriptionSignal.value = event.target.value
	}

	const selectForm = function (event) {
		fileSignal.value = event.target.files[0]
		diskFileNameSignal.value = event.target.files[0].name
		if (!userEnteredFormNameSignal.value) {
			userEnteredFormNameSignal.value = diskFileNameSignal.value
		}
		mimeTypeSignal.value = event.target.files[0].type
	}

	const uploadForm = async function () {
		const device = {
			deviceType: selectedDeviceTypeSignal.value,
			name: userEnteredFormNameSignal.value,
			description: descriptionSignal.value,
			filename: diskFileNameSignal.value,
			mimeType:mimeTypeSignal.value,
			businessEntityId: beId
		}
		createDeviceForm(beId, device, fileSignal.value, config, accessToken)
		handleCancel()
		resetForm()
	}

	const resetForm = () => {
		diskFileNameSignal.value = null
		selectedDeviceTypeSignal.value = null
		userEnteredFormNameSignal.value = null
		descriptionSignal.value = ''
		mimeTypeSignal.value = 'application/octet-stream'
		document.getElementById("uploadFormForm").reset()
	}

	/**
	 * Returns true if the provided device type short code supports forms, false if otherwise
	 * Device codes are similar to those used as keys in ComponentDeviceTypeFormsUnsupported and ComponentDeviceType.
	 * If the device code is not present in ComponentDeviceTypeFormsUnsupported, it is assumed that it is supported.
	 * @param string type : 
	 * @returns bool
	 */
	const deviceTypeSupportsForms = function (type) {
		return !(type.toLowerCase() in ComponentDeviceTypeFormsUnsupported)
	}

	function SelectOptions({ items }) {
		let options = []
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				const item = items[i]
				if (deviceTypeSupportsForms(item.key)) {
					options.push(<option key={item.key} value={`${item.key}`}>{`${item.name}`}</option>)
				}
				
			}
		}
		return options.length == 0? null : options
	}

	return (
		<Modal show={show} onHide={handleCancel}>
			<Modal.Header closeButton>
				<Modal.Title>Upload Form</Modal.Title>
			</Modal.Header>
			<Form id="uploadFormForm">
				<Modal.Body>
					<Form.Group className="mb-3">
						<Form.Label htmlFor="userEnteredFormName" /*className="col-xs-4 cols-sm-4 control-label"*/>Name</Form.Label>
						<div /*className="col-xs-8 cols-sm-6"*/>
							<Form.Control id="userEnteredFormName" name="userEnteredFormName" className="form-control" value={userEnteredFormNameSignal.value} type="text" required={false} placeholder={'Enter form name (optional)'} onChange={handleUserEnteredFormNameChanged}></Form.Control>
						</div>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label /*className="col-xs-3 control-label"*/ htmlFor="deviceType">Device Type</Form.Label>
						<div /*className="col-xs-9"*/>
							<Form.Select id="deviceType" name="deviceType" className='form-control' required aria-required="true" onChange={handleDeviceTypeChange} value={selectedDeviceTypeSignal.value}>
								<option value=''>Select Device Type</option>
								<SelectOptions items={deviceTypes}></SelectOptions>
							</Form.Select>
						</div>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label htmlFor="description">Description</Form.Label>
						<div>
							<Form.Control id="description" name="description" className="form-control" value={descriptionSignal.value} type="text" required={false} placeholder={'Enter description (optional)'} onChange={handleDescriptionChanged}></Form.Control>
						</div>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label /*className="col-xs-3 control-label"*/ htmlFor="forms"></Form.Label>
						<div /*className="col-xs-9"*/>
							<Form.Control type="file" id="formFileInput" name="forms" accept=".tgz,.zip" onChange={selectForm} />
						</div>
						<div /*className="col-xs-9"*/>
							<Form.Label>{diskFileNameSignal.value}</Form.Label>
						</div>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer className="modal-footer">
					<Button type="button" onClick={handleCancel}>Cancel</Button>
					<Button type="button" onClick={uploadForm} disabled={!enableUploadButtonComputed.value}>Upload</Button>
				</Modal.Footer>
			</Form>
		</Modal >
	)
}

export default UploadFormModal